import BaseModel from './base';
import CertificateProfile from './certificate-profile';
import OrganizerProfile from './organizer-profile';
import { rServices } from '@/plugins/api';
/**
 * @param {*} users_id - Array | Number
 * @returns {Promise} Array
 */
export const fetchUser = (users_id) => {
  const params = {
    'search[id]': users_id,
    expand: 'profile,certificate,directory_attributes,organizer',
  };

  return rServices.user.getPublicUsersCached({ params });
};

export default class User extends BaseModel {
  constructor(user, url) {
    super(user, url);

    this.status = user.status;
    this.request_id = user.request_id;
    this.profile = user.profile ? new CertificateProfile(user.profile) : null;
    this.organizer = user.organizer ? new OrganizerProfile(user.organizer) : null;
    this.name = this.profile?.name || [this.profile?.last_name, this.profile?.first_name, this.profile?.middle_name].join(' ').trim() || '';
    this.certificate = user.certificate || 'Нет данных';
    this.username = user.username || '';
  }
}
